import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="flex flex-wrap items-center gap-2 text-xs text-foreground-400">
      <Link to="/" className="flex items-center gap-1 transition-colors hover:text-primary-600">
        <i className="ri-home-4-line" />
        首页
      </Link>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line" />
          {item.to ? (
            <Link to={item.to} className="transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-600">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}